module.exports = __webpack_public_path__ + "media/images/games/35reveal/mountain-4849d9d3fd9b434c139cca2f93defdb6.png";